/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Browser tarafındaki insan oturumu yalnız HttpOnly session cookie ile taşınır.
 * Bu marker bir credential değildir; eski host sözleşmelerinin oturum var/yok
 * durumunu temsil edebilmesi için tutulur.
 */

export const COOKIE_ONLY_SESSION_MARKER = 'cookie-based-token' as const;

/**
 * Eski hostlar login/refresh/initialAuth içinde token gönderse bile ham değer
 * browser state'ine alınmaz. Geçerli oturumun tek kanıtı HttpOnly cookie'dir.
 */
export function toCookieOnlySessionMarker(
  _legacyToken?: unknown,
): typeof COOKIE_ONLY_SESSION_MARKER {
  return COOKIE_ONLY_SESSION_MARKER;
}

/** İnsan API isteğinden custom header ile enjekte edilmiş Bearer dahil auth'u siler. */
export function clearHumanAuthorizationHeader(headers?: unknown): void {
  if (!headers || typeof headers !== 'object') return;
  const candidate = headers as {
    delete?: (name: string) => void;
    Authorization?: unknown;
    authorization?: unknown;
  };
  if (typeof candidate.delete === 'function') {
    candidate.delete('Authorization');
    candidate.delete('authorization');
  }
  for (const key of Object.keys(candidate)) {
    if (key.toLowerCase() === 'authorization') {
      delete (candidate as Record<string, unknown>)[key];
    }
  }
}
